import { MISSION_BY_ID } from '../../data/missions';
import { HUMAN_PLAYER_INDEX } from '../../domain/types';
import { useGameStore } from '../../store/gameStore';
import { MissionCard } from './MissionCard';

const DRAFT_PICK_COUNT = 5;

export function MissionDraftPickedSection() {
  const game = useGameStore((s) => s.game);
  const { phase, players } = game;

  if (phase !== 'mission_draft') return null;

  const human = players[HUMAN_PLAYER_INDEX];
  if (!human) return null;

  const picked = human.draftedMissions;

  return (
    <div className="overlay-panel p-3">
      <h2 className="mb-2 text-xs font-semibold uppercase tracking-wide text-amber-200/80">
        선택 완료 {picked.length}/{DRAFT_PICK_COUNT}
      </h2>
      {picked.length === 0 ? (
        <p className="text-xs text-white/55">아직 선택한 미션이 없습니다</p>
      ) : (
        <div className="flex gap-2 overflow-x-auto pb-1">
          {picked.map((id) => {
            const mission = MISSION_BY_ID[id];
            if (!mission) return null;
            return <MissionCard key={id} mission={mission} variant="compact" />;
          })}
        </div>
      )}
    </div>
  );
}
